// @ts-ignore
import styled from '@react-pdf/styled-components';

export const Col = styled.View``;

export const Entry = styled.View`
  margin-bottom: 2mm;
`;

export const Text = styled.Text`
  font-family: 'averta-regular';
  font-size: 10;
  color: #90a4ae;
  margin-bottom: 1mm;
  margin-right: 25mm;
`;

export const DependencyWrapper = styled.View`
  max-width: 65%;
  transform-origin: left center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  flex-wrap: nowrap;
`;

export const Dependency = styled.Text`
  font-family: 'averta-regular';
  font-size: 10;
  color: #90a4ae;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
`;
